import { createFileRoute, redirect } from '@tanstack/react-router';

/** Alias legacy `/bookings/car-history` → redirect a `/car-history` preservando i search params. */
export const Route = createFileRoute('/_app/bookings/car-history')({
  validateSearch: (s: Record<string, unknown>) => ({
    vehicleId: typeof s.vehicleId === 'string' ? s.vehicleId : undefined,
    employeeId: typeof s.employeeId === 'string' ? s.employeeId : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/car-history', search });
  },
});
